export interface ShopifyTokenGenerator {
  get(): Promise<string>;
}

export const getShopifyAuthHeader = async (
  shopifyTokenGenerator?: ShopifyTokenGenerator
): Promise<Record<string, string> | undefined> => {
  if (!shopifyTokenGenerator) {
    return undefined;
  }

  return {
    Authorization: `Bearer ${await shopifyTokenGenerator.get()}`,
  };
};
